<pf-listview [items]="packages" [title]="'package.title' | translate" [addRouterLink]="'/addpackage'"
    [hasSearchSection]="true" [searchPlaceholder]="'package.searchPlaceholder' | translate"
    [saveButtonText]="('admin.save' | translate | uppercase)" [useDragDrop]="true" (save)="updatePackagesOrder()"
    [useSaveButton]="true">
    <ng-template #itemTemplate let-package let-i="index">
        <div class="banner-row-layout">
            <div class="name-link" [routerLink]="package.routerLink">
                {{ package.packageName }}
            </div>

            <div class="status-block" style="min-width: 50px;">
                <div class="delete">
                    <mat-icon (click)="openDeletePackageDialog(package); $event.stopPropagation()">
                        delete_forever
                    </mat-icon>
                </div>
            </div>
        </div>
    </ng-template>
</pf-listview>